/* eslint-disable import/no-anonymous-default-export */
import { LinkOutlined } from "@ant-design/icons"
import { Avatar, Carousel } from "antd"
import axios from "axios"
import { useState } from "react"
import { useEffect } from "react"

export default ({
    fileData = []
}) => {
    const [fileUrl, setFileUrl] = useState([])
    useEffect(() => {
        get_picture(fileData)
        return ()=>{
            setFileUrl([])
        }
    }, [fileData])
    const get_picture = (fileDataTemp) => {
        if (fileDataTemp.length != 0) {
            fileDataTemp.map((tmp, key) => {
                axios
                    .get('/component/file', { responseType: 'blob', params: { "file_id": tmp.file_id } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        // console.log(dataurl)
                        setFileUrl(prev=>[...prev,dataurl])

                    })
            })
        }
    }
    return (<>
        <div
            style={{
                margin: 0,
                maxHeight: '64px',
                width: '64px',
            }}
        >
            <Carousel
                autoplay
            >
                {fileUrl ? fileUrl.map((tmp, index) => (<>
                    <div>
                        <Avatar size={64} src={tmp} />
                    </div>
                </>)) : (<>
                    <div>
                        <Avatar size={64} icon={<LinkOutlined />} />
                    </div>
                </>)}
            </Carousel>
        </div>
    </>)
}